import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import ItemStatusModel from '../../models/ItemStatusModel';
import DataService from "../../services/data.service";

const ItemStatuses: React.FC = () => {
    const [data, setData] = useState<any[]>();
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<any[]>('api/v1/itemstatuses')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function add() {
        navigate('/plm/itemsetup/itemstatus/add', { state: { title: 'New itemstatus', fromMenu: false } });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/itemstatuses/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    function getCellColor(itemStatus: ItemStatusModel, colInfo: IColInfo): string | undefined {
        return itemStatus.color;
    }

    const colInfos: IColInfo[] = [
        { title: 'ID', key: true, dataProp: 'id', dataType: 'number' },
        { title: 'Kleur', getCellBackgroundColor: getCellColor, sort: false },
        { title: 'Type', dataProp: 'itemStatusType.name', sort: 'asc', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Name', dataProp: 'name', filterInfo: { filterType: 'Textbox' } },
        { title: 'Sort Order', dataProp: 'sortOrder', dataType: 'number' },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'date' },
        { title: 'End date', dataProp: 'endDate', dataType: 'date' },

    ];
    if (isAuthorizedFor(ApplicationFunctions.EditItemStatus)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: add }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    return (
        <>
            <div className='main-content'>
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <Card title='Itemstatuses'
                                content={
                                    <DataTable
                                        name='dtItemStatuses'
                                        tableData={data}
                                        colInfos={colInfos}
                                        navigateTitle='Itemstatus'
                                        navigateUrl='/plm/itemsetup/itemstatus/'
                                    />
                                }
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
export default ItemStatuses;